/**
 * 生成验证码图片URL
 * @param {string} code - 4个字符的字符串（如：'A3f7'）
 * @returns {string} 验证码图片的DataURL
 */
export function generateCaptchaUrl(code) {
    // 校验输入（确保是4个字符）
    if (!code || code.length !== 4) {
        throw new Error("请传入4个字符的验证码内容");
    }

    // 创建Canvas
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const width = 140;  // 画布宽度
    const height = 50;  // 画布高度
    canvas.width = width;
    canvas.height = height;

    // 1. 绘制背景（带渐变和噪点）
    const gradientBg = ctx.createLinearGradient(0, 0, width, height);
    gradientBg.addColorStop(0, `rgba(${245 + Math.random() * 10}, ${245 + Math.random() * 10}, ${245 + Math.random() * 10}, 1)`);
    gradientBg.addColorStop(1, `rgba(${230 + Math.random() * 15}, ${230 + Math.random() * 15}, ${230 + Math.random() * 15}, 1)`);
    ctx.fillStyle = gradientBg;
    ctx.fillRect(0, 0, width, height);

    // 添加背景噪点
    for (let i = 0; i < 80; i++) {
        ctx.fillStyle = `rgba(${Math.random() * 100}, ${Math.random() * 100}, ${Math.random() * 100}, ${0.3 + Math.random() * 0.5})`;
        ctx.beginPath();
        ctx.arc(
            Math.random() * width,
            Math.random() * height,
            0.5 + Math.random() * 1.5,
            0,
            Math.PI * 2
        );
        ctx.fill();
    }

    // 2. 绘制字符（随机角度、大小、颜色）
    const charPositions = [25, 50, 75, 100];  // 字符大致X坐标
    code.split('').forEach((char, index) => {
        // 随机颜色（深色，与背景区分）
        const color = `rgb(${30 + Math.random() * 80}, ${30 + Math.random() * 80}, ${30 + Math.random() * 80})`;
        // 随机字体大小（22-30px）
        const fontSize = 22 + Math.random() * 8;
        // 随机旋转角度（-30° 到 30°）
        const rotate = (Math.random() * 60 - 30) * Math.PI / 180;
        // 随机Y坐标偏移（±5px）
        const yOffset = (Math.random() * 10 - 5);

        ctx.save();
        // 移动到字符位置
        ctx.translate(charPositions[index], height / 2 + yOffset);
        // 旋转
        ctx.rotate(rotate);
        // 设置文字样式
        ctx.font = `bold ${fontSize}px Arial, SimHei, sans-serif`;
        ctx.fillStyle = color;
        ctx.textBaseline = 'middle';
        ctx.textAlign = 'center';
        // 绘制字符
        ctx.fillText(char, 0, 0);
        ctx.restore();
    });

    // 3. 添加干扰线（2-3条）
    const lineCount = 2 + Math.floor(Math.random() * 2);
    for (let i = 0; i < lineCount; i++) {
        ctx.strokeStyle = `rgba(${80 + Math.random() * 80}, ${80 + Math.random() * 80}, ${80 + Math.random() * 80}, ${0.5 + Math.random() * 0.3})`;
        ctx.lineWidth = 1 + Math.random() * 1.5;
        ctx.beginPath();
        // 随机起点和终点
        ctx.moveTo(
            Math.random() * width * 0.3,
            Math.random() * height
        );
        ctx.lineTo(
            width - Math.random() * width * 0.3,
            Math.random() * height
        );
        ctx.stroke();
    }

    // 转换为DataURL并返回（png格式）
    return canvas.toDataURL('image/png');
}

// // ------------------------------
// // 使用示例：
// // ------------------------------
// // 生成4个随机字符（数字+大小写字母）
// const getRandomCode = () => {
//     const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
//     let code = '';
//     for (let i = 0; i < 4; i++) {
//         code += chars[Math.floor(Math.random() * chars.length)];
//     }
//     return code;
// };

// // 生成验证码图片URL
// const randomCode = getRandomCode();
// const captchaUrl = generateCaptchaUrl(randomCode);
// console.log('验证码字符：', randomCode);
// console.log('验证码图片URL：', captchaUrl);

// // 在页面中展示（可直接插入img标签）
// // const img = document.createElement('img');
// // img.src = captchaUrl;
// // document.body.appendChild(img);